export const images = [
	`${process.env.PUBLIC_URL}/Yosemite.jpg`,
	`${process.env.PUBLIC_URL}/PacificOcean.jpg`,
	`${process.env.PUBLIC_URL}/MtHood.jpg`,
	`${process.env.PUBLIC_URL}/GrandCanyon.jpg`
];

// hehehehe, hackity hack hack
export const skills = [
	'Websites',
	'Mobile apps',
	'Automation Scripts',
	'Electron Apps',
	'Node.JS Servers',
	'Websites',
	'Mobile apps',
	'Automation Scripts',
	'Electron Apps',
	'Node.JS Servers',
	'Websites',
	'Mobile apps',
	'Automation Scripts',
	'Electron Apps',
	'Node.JS Servers',
	'Websites',
	'Mobile apps',
	'Automation Scripts',
	'Electron Apps',
	'Node.JS Servers',
	'Websites',
	'Mobile apps',
	'Automation Scripts',
	'Electron Apps',
	'Node.JS Servers',
	'Websites',
	'Mobile apps',
	'Automation Scripts',
	'Electron Apps',
	'Node.JS Servers',
	'Websites',
	'Mobile apps',
	'Automation Scripts',
	'Electron Apps',
	'Node.JS Servers',
	'Websites',
	'Mobile apps',
	'Automation Scripts',
	'Electron Apps',
	'Node.JS Servers',
	'Websites',
	'Mobile apps',
	'Automation Scripts',
	'Electron Apps',
	'Node.JS Servers',
	'Websites',
	'Mobile apps',
	'Automation Scripts',
	'Electron Apps',
	'Node.JS Servers',
	'Websites',
	'Mobile apps',
	'Automation Scripts',
	'Electron Apps',
	'Node.JS Servers',
	'Websites',
	'Mobile apps',
	'Automation Scripts',
	'Electron Apps',
	'Node.JS Servers',
	'Websites',
	'Mobile apps',
	'Automation Scripts',
	'Electron Apps',
	'Node.JS Servers',
	'Websites',
	'Mobile apps',
	'Automation Scripts',
	'Electron Apps',
	'Node.JS Servers',
	'Websites',
	'Mobile apps',
	'Automation Scripts',
	'Electron Apps',
	'Node.JS Servers',
	'Websites',
	'Mobile apps',
	'Automation Scripts',
	'Electron Apps',
	'Node.JS Servers',
	'Websites',
	'Mobile apps',
	'Automation Scripts',
	'Electron Apps',
	'Node.JS Servers',
	'Websites',
	'Mobile apps',
	'Automation Scripts',
	'Electron Apps',
	'Node.JS Servers',
	'Websites',
	'Mobile apps',
	'Automation Scripts',
	'Electron Apps',
	'Node.JS Servers'
];



// WEBPACK FOOTER //
// ./src/config/carousel.js